import { Text } from "@radix-ui/themes";

interface HeadingBlockProps {
  level: 1 | 2 | 3;
  text: string;
}

export function HeadingBlock({ level, text }: HeadingBlockProps) {
  if (level === 1) {
    return (
      <div>
        <Text
          as="p"
          size="7"
          weight="bold"
          className="tracking-tight text-puntt-neutral-gray-12"
        >
          {text}
        </Text>
        <div className="mt-2 h-1 w-16 rounded-full bg-puntt-accent-9" />
      </div>
    );
  }

  if (level === 2) {
    return (
      <div>
        <Text
          as="p"
          size="4"
          weight="bold"
          className="border-l-4 border-puntt-accent-9 pl-3.5 tracking-tight text-puntt-neutral-gray-12"
        >
          {text}
        </Text>
      </div>
    );
  }

  return (
    <div>
      <Text
        as="p"
        size="2"
        weight="bold"
        className="uppercase tracking-wide text-puntt-neutral-gray-11"
      >
        {text}
      </Text>
    </div>
  );
}
